<nav class="barra theme-bg theme-bg-2 theme-text theme-title" aria-label="Navegación principal">
  <a class="pestana invisible" href="/" appGoToUrl [class.activa]="seccion() === 'inicio'" [attr.aria-current]="seccion() === 'inicio' ? 'page' : null">
    <app-icon aria-hidden="true" src="/assets/icons/new_design/home.svg"></app-icon>
    <span>Inicio</span>
  </a>

  <a class="pestana invisible" href="/categorias/" appGoToUrl [class.activa]="seccion() === 'categorias'" [attr.aria-current]="seccion() === 'categorias' ? 'page' : null">
    <app-icon aria-hidden="true" src="/assets/icons/new_design/category.svg"></app-icon>
    <span>Categorías</span>
  </a>

  <div class="hueco">
    <button type="button" class="comparte" aria-label="Comparte un chollo" title="Comparte un chollo" (click)="compartir($event)">
      <app-icon aria-hidden="true" src="/assets/icons/new_design/plus.svg"></app-icon>
    </button>
  </div>

  @if (urlAlertas(); as url) {
    <a class="pestana invisible" [href]="url" appGoToUrl [class.activa]="seccion() === 'alertas'" [attr.aria-current]="seccion() === 'alertas' ? 'page' : null">
      <span class="icono_con_aviso">
        <app-icon aria-hidden="true" src="/assets/icons/new_design/bell.svg"></app-icon>
        @if (avisosSinLeer(); as n) { <span class="contador_avisos" aria-hidden="true">{{ n }}</span> }
      </span>
      <span>Alertas</span>
      @if (avisosSinLeer(); as n) { <span class="mc-titulo-accesible">, {{ n }} sin leer</span> }
    </a>
  } @else {
    <button type="button" class="pestana" (click)="pulsarProtegido($event)">
      <app-icon aria-hidden="true" src="/assets/icons/new_design/bell.svg"></app-icon>
      <span>Alertas</span>
    </button>
  }

  @if (urlPerfil(); as url) {
    <a class="pestana invisible" [href]="url" appGoToUrl [class.activa]="seccion() === 'perfil'" [attr.aria-current]="seccion() === 'perfil' ? 'page' : null">
      <app-icon aria-hidden="true" src="/assets/icons/new_design/user.svg"></app-icon>
      <span>Perfil</span>
    </a>
  } @else {
    <button type="button" class="pestana" (click)="pulsarProtegido($event)">
      <app-icon aria-hidden="true" src="/assets/icons/new_design/user.svg"></app-icon>
      <span>Perfil</span>
    </button>
  }
</nav>
